import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

import { parseQs, stringifyQs } from 'helpers/http';

import ListFilterBody from 'components/layout/list/ListFilterBody';
import ListFilterListEntry from 'components/layout/list/ListFilterListEntry';

class ListFilterItemActive extends React.Component {
  updateActive = (e, isActive) => {
    e.preventDefault();

    const { location, history } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQs({ ...parseQs(location.search), isActive }),
    });
  };

  reset = e => {
    this.updateActive(e, undefined);
  };

  render() {
    const {
      intl: { messages },
      location,
    } = this.props;

    const query = parseQs(location.search);
    const isActive = query.isActive !== undefined;

    return (
      <ListFilterBody
        title={messages.item_filter_is_active}
        isActive={isActive}
        paramNames={['isActive']}
        body={
          <div className="list-view clearfix">
            <ul className="no-border">
              <li>
                <a className="p-t-5 p-b-5 relative block" href="#all" onClick={this.reset}>
                  <ListFilterListEntry isChecked={query.isActive === undefined} label={messages.all} />
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updateActive"
                  onClick={e => this.updateActive(e, 'true')}
                >
                  <ListFilterListEntry isChecked={query.isActive === 'true'} label={messages.yes} />
                </a>
              </li>

              <li>
                <a
                  className="p-t-5 p-b-5 relative block"
                  href="#updateActive"
                  onClick={e => this.updateActive(e, 'false')}
                >
                  <ListFilterListEntry isChecked={query.isActive === 'false'} label={messages.no} />
                </a>
              </li>
            </ul>
          </div>
        }
      />
    );
  }
}
ListFilterItemActive.defaultProps = {};

export default withRouter(injectIntl(ListFilterItemActive));
